import { createTheme } from '@mui/material/styles';
import { enUS, deDE, esES, plPL, ruRU } from '@mui/material/locale';
import { theme } from './theme';

const locales = {
    DEFAULT: enUS,
    en: enUS,
    de: deDE,
    es: esES,
    pl: plPL,
    ru: ruRU,
};

export function createLocalizedTheme(lang) {
    const locale = locales[lang] || locales.DEFAULT;
    return createTheme(theme, locale);
}
